import { services } from "../../../../constants";

export default async function ebillingServices(data) {
  const url = `${this.backendHosts.settings}${services.ebilling}`;
  try {
    const response = await this.http.post(url, data, await this.getHeaders());
    return response;
  } catch (error) {
    this.handleErrorResponse(error);
  }
}
